<template>
  <base-card>
    <template v-slot:header>
      <base-card-heading>Net Asset Statement</base-card-heading>
      <base-button primary small :to="{ name: 'asset-statements' }">
        Edit
      </base-button>
    </template>

    <dl class="row mb-0">
      <dt class="col-sm-6">Status</dt>
      <dd class="col-sm-6">Incomplete</dd>
      <dt class="col-sm-6">Net Asset Value</dt>
      <dd class="col-sm-6">{{ total }}</dd>
    </dl>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AssetStatementProgress',

  async created () {
    await this.$store.dispatch('core/asset-statements/list', {
      options: {
        query: {
          user: this.$auth.user._id
        }
      }
    })
  },

  computed: {
    total () {
      return this.$formatting.toCurrency(this.$_.sumBy(this.assetStatements, 'totalNetWorth'))
    },

    ...mapState({
      assetStatements: store => store.core.assetStatements.rows
    })
  }
}
</script>
